module.exports = __webpack_public_path__ + "img/sankaku_64_red.601caa60.png";